export enum VTEntryModeType {
  telephone = 'telephone-order',
  email = 'mail-order'
}
